import React from "react";
import { useState } from "react";
import { Container, Row, Col, Form, FormGroup, Input } from "reactstrap";
import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";

import "../styles/contact.css";

const socialLinks = [
  {
    url: "https://www.facebook.com/sankhultd",
    icon: "ri-facebook-line",
  },
  {
    url: "#",
    icon: "ri-instagram-line",
  },
  {
    url: "#",
    icon: "ri-google-line",
  },
  {
    url: "https://api.whatsapp.com/send/?phone=254750542046",
    icon: "ri-whatsapp-line",
  },
];

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const generateWhatsAppLink = () => {
    const { name, email, phoneNumber, message } = formData;
    const encodedMessage = `Hello from Sankhu Website: Name: ${encodeURIComponent(
      name
    )} Email: ${encodeURIComponent(email)} Phone Number: ${encodeURIComponent(
      phoneNumber
    )} Message: ${encodeURIComponent(message)}`;
    return `https://wa.me/254750542046?text=${encodedMessage}`;
  };

  const handleEmailSubmit = () => {
    const { name, email, phoneNumber, message } = formData;
    const subject = encodeURIComponent("Sankhu Contact Form Submission");
    const body = encodeURIComponent(
      ` CustomerName: ${name} 
        Email: ${email} 
        Phone Number: ${phoneNumber}
        Message: ${message}`
    );

    const mailtoLink = `mailto:info.sankhultd@gmail.com?subject=${subject}&body=${body}`;

    window.open(mailtoLink, "_blank");
  };

  return (
    <Helmet title="Contact">
      <CommonSection title="Contact" />
      <section>
        <Container>
          <Row>
            <Col lg="7" md="7">
              <h6 className="fw-bold mb-4">Get In Touch</h6>

              <Form onSubmit={handleEmailSubmit}>
                <FormGroup className="contact__form">
                  <Input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </FormGroup>
                <FormGroup className="contact__form">
                  <Input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </FormGroup>
                <FormGroup className="contact__form">
                  <Input
                    type="text"
                    name="phoneNumber"
                    placeholder="Phone Number"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                  />
                </FormGroup>
                <FormGroup className="contact__form">
                  <textarea
                    rows="5"
                    name="message"
                    placeholder="Message"
                    className="textarea"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </FormGroup>
                <div className="d-flex justify-content-center">
                  <a
                    href={generateWhatsAppLink()}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="contact__btn m-2" type="button">
                      Whatsapp Us
                    </button>
                  </a>
                  <button
                    className="contact__btn m-2"
                    type="button"
                    onClick={handleEmailSubmit}
                  >
                    Send Email
                  </button>
                  <a href="tel:+254113474733">
                    <button className="contact__btn m-2" type="button">
                      Call Us Now
                    </button>
                  </a>
                </div>
              </Form>
            </Col>

            <Col lg="5" md="5">
              <div className="contact__info">
                <h6 className="fw-bold">Contact Information</h6>
                <p className="section__description mb-0">
                  Hurlingham Plaza, Argwings Kodhek. <br /> Nairobi, Kenya. (2nd
                  Floor Rm C14)
                </p>
                <div className=" d-block align-items-center gap-2">
                <h6 className="fs-6 mb-0">Office Phone:</h6>
                  <p className="section__description mb-0">+254113474733</p>
                  <h6 className="fs-6 mb-0">Mobile Phone:</h6>
                  <p className="section__description mb-0">+254115554156</p>
                  <h6 className="fs-6 mb-0">Whatsapp:</h6>
                  <p className="section__description mb-0">+254750542046</p>
                </div>

                <div className=" d-flex align-items-center gap-2">
                  <h6 className="mb-0 fs-6">Email:</h6>
                  <p className="section__description mb-0">
                    info.sankhultd@gmail.com
                  </p>
                </div>

                <h6 className="fw-bold mt-4">Follow Us</h6>

                <div className=" d-flex align-items-center gap-4 mt-3">
                  {socialLinks.map((item, index) => (
                    <a
                    href={item.url}
                    key={index}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social__link-icon"
                  >
                    <i className={item.icon}></i>
                  </a>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default Contact;
